import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TenantContextService } from '@core/tenant/tenant-context.service';

/**
 * Adds `X-Tenant-Id: <tenantId>` to every outbound HTTP request. The backend
 * uses this for partition routing so tenant isolation extends past the
 * client.
 *
 * Skipped when:
 *  - The request URL is absolute and points at a non-API origin (assets,
 *    third-party CDNs).
 *  - The header is already set by the caller (allows explicit override).
 */
export const tenantHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const tenants = inject(TenantContextService);

  if (req.headers.has('X-Tenant-Id')) {
    return next(req);
  }

  const tenantId = tenants.currentTenant().id;
  return next(req.clone({ setHeaders: { 'X-Tenant-Id': tenantId } }));
};
